import { Component, OnInit } from '@angular/core';
import { ShowSmallComponent } from '../../components/show-small/show-small.component';

import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-home',
  imports: [ShowSmallComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  title = 'News';
  content =
    'We will be doing some shows again this year. Stay tuned for more information.';
  filteredShows: any[] = [];
  upcomingShows = [];

  constructor(private api: ApiService) {}

  ngOnInit() {
    // try to load upcoming shows from API, fall back to static list on error
    this.api.get<any[]>('/shows/shows?onlyUpcoming=true').subscribe({
      next: (data) => {
        this.filteredShows = data.map((s) => ({
          ...s,
          date: s.date ? new Date(s.date) : null,
        }));
      },
      error: (err) => {
        console.warn('Failed to load shows from API, using static list', err);
      },
    });
  }
}
